// extracted by mini-css-extract-plugin
export var lg = "_k2-7";
export var md = "_k2-6";
export var placeholderContainer = "_k2-1";
export var placeholderIcon = "_k2-2";
export var productImage = "_k2-0";
export var sm = "_k2-5";
export var xl = "_k2-8";
export var xs = "_k2-4";
export var xxs = "_k2-3";